<template>
  <div class="hitwrapper utbildning">
    <div class="hittitle">
      <a :href="hit.url">
        {{ hit.title }},
        {{ hit.credits }}
        <Icon type="arrow-right" />
      </a>
    </div>
    <div class="kortfakta">
      <span class="fakta"
        ><Icon :type="'fa-book'" />{{
          getUtbildningTyp(hit.typeName, hit.eduLevel)
        }}</span
      >
      <span class="fakta"
        ><Icon :type="'fa-clock'" />{{ hit.studietakt }}</span
      >
      <span class="fakta"
        ><Icon :type="'fa-location-dot'" />{{
          getStudieOrt(hit.studieort)
        }}</span
      >
      <span class="fakta"
        ><Icon :type="'fa-landmark'" />{{ hit.studieform }}</span
      >   
    </div>
  </div>
</template>
<script>
import Icon from "../../../image/icon.vue";
export default {
  name: "UtbildningItem",
  props: {
    hit: Object,
    texts: Object,
  },
  components: {
    Icon,
  },
  methods: {
    getUtbildningTyp(typeName, eduLevel) {
      const level = eduLevel === null ? "" : eduLevel.toLowerCase();
      if (typeName === "cms.models.blocks.utbildning.programblock") {
        return this.texts.program + (level ? ", " + level : "");
      } else if (typeName === "cms.models.blocks.utbildning.kursblock") {
        return this.texts.kurs + (level ? ", " + level : "");
      } else if (typeName === "cms.models.blocks.utbildning.kurspaketblock") {
        return this.texts.kurspaket + (level ? ", " + level : "");
      }
    },
    getStudieOrt(studieort) {
      if (studieort === null) {
        return "";
      }
      return studieort.charAt(0).toUpperCase() + studieort.slice(1);
    },
  },
};
</script>
